import { Basket } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedItem } from '../checkout-completed-item/checkout-completed-item.interface';

export interface CheckoutResponse<
  T extends CheckoutCompletedItem = CheckoutCompletedItem
> {
  completedItems: T[];
  basket: Basket;
  weight?: number;
}
